var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 91,
    viewBox: "0 0 95 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3401_4609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0759 19.9371C13.0759 12.7921 18.8681 7 26.013 7H69.0028C76.1478 7 81.9399 12.7921 81.9399 19.9371V58.0629C81.9399 65.2079 76.1478 71 69.0028 71H26.013C18.8681 71 13.0759 65.2079 13.0759 58.0629V19.9371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.013 7.40428H69.0028C75.9245 7.40428 81.5356 13.0154 81.5356 19.9371V58.0629C81.5356 64.9846 75.9245 70.5957 69.0028 70.5957H26.013C19.0914 70.5957 13.4802 64.9846 13.4802 58.0629V19.9371C13.4802 13.0154 19.0913 7.40428 26.013 7.40428Z",
    stroke: "#B1C1CF",
    strokeWidth: 0.808569
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 31.5964V42.4297H45V38.0964C45 37.5217 45.2107 36.9706 45.5858 36.5643C45.9609 36.158 46.4696 35.9297 47 35.9297H52C52.5304 35.9297 53.0391 36.158 53.4142 36.5643C53.7893 36.9706 54 37.5217 54 38.0964V42.4297H56V31.5964H40ZM36 46.763V44.5964H40C39.4696 44.5964 38.9609 44.3681 38.5858 43.9618C38.2107 43.5554 38 43.0043 38 42.4297V31.5964C38 31.0217 38.2107 30.4706 38.5858 30.0643C38.9609 29.658 39.4696 29.4297 40 29.4297H56C56.5304 29.4297 57.0391 29.658 57.4142 30.0643C57.7893 30.4706 58 31.0217 58 31.5964V42.4297C58 43.0043 57.7893 43.5554 57.4142 43.9618C57.0391 44.3681 56.5304 44.5964 56 44.5964H60V46.763H54C54 47.3377 53.7893 47.8888 53.4142 48.2951C53.0391 48.7014 52.5304 48.9297 52 48.9297H47C46.4696 48.9297 45.9609 48.7014 45.5858 48.2951C45.2107 47.8888 45 47.3377 45 46.763H36ZM47.5 46.763C47.3674 46.763 47.2402 46.8201 47.1464 46.9217C47.0527 47.0233 47 47.161 47 47.3047C47 47.4483 47.0527 47.5861 47.1464 47.6877C47.2402 47.7893 47.3674 47.8464 47.5 47.8464C47.6326 47.8464 47.7598 47.7893 47.8536 47.6877C47.9473 47.5861 48 47.4483 48 47.3047C48 47.161 47.9473 47.0233 47.8536 46.9217C47.7598 46.8201 47.6326 46.763 47.5 46.763ZM51.5 46.763C51.3674 46.763 51.2402 46.8201 51.1464 46.9217C51.0527 47.0233 51 47.161 51 47.3047C51 47.4483 51.0527 47.5861 51.1464 47.6877C51.2402 47.7893 51.3674 47.8464 51.5 47.8464C51.6326 47.8464 51.7598 47.7893 51.8536 47.6877C51.9473 47.5861 52 47.4483 52 47.3047C52 47.161 51.9473 47.0233 51.8536 46.9217C51.7598 46.8201 51.6326 46.763 51.5 46.763ZM49 46.763V47.8464H50V46.763H49ZM46.5 37.5547V45.6797H52.5V37.5547H46.5Z",
    fill: "#243251"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3401_4609",
    x: 0.138817,
    y: 0.531445,
    width: 94.7382,
    height: 89.8742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.46856
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.46856
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.686275 0 0 0 0 0.776471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3401_4609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3401_4609",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile3);
export default __webpack_public_path__ + "static/media/Mobile3.bb5a31bfe4f3392a0e56880a6c338bcb.svg";
export { ForwardRef as ReactComponent };